import { Dispatch, SetStateAction } from "react";
import { ICitationFormInput } from "../CitationAction.interface";
import CitationGeneratorFooter from "./CitationGeneratorFooter";
import CitationGeneratorBody from "./CitationGeneratorBody";
import { citationGeneratorBodyWrapperCss } from "./CitationGenerator.style";

interface CitationGeneratorProps {
  citationData: ICitationFormInput;
  handleDismiss: () => void;
  setShowEditForm: Dispatch<SetStateAction<boolean>>;
}

const CitationGenerator = ({
  citationData,
  handleDismiss,
  setShowEditForm,
}: CitationGeneratorProps) => {
  return (
    <div css={citationGeneratorBodyWrapperCss}>
      <CitationGeneratorBody
        setShowEditForm={setShowEditForm}
        citationData={citationData}
      />
      <CitationGeneratorFooter handleDismiss={handleDismiss} />
    </div>
  );
};

export default CitationGenerator;
